import { render, staticRenderFns } from "./VideoSvg.vue?vue&type=template&id=95b135f0&scoped=true"
import script from "./VideoSvg.vue?vue&type=script&lang=js"
export * from "./VideoSvg.vue?vue&type=script&lang=js"
import style0 from "./VideoSvg.vue?vue&type=style&index=0&id=95b135f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b135f0",
  null
  
)

export default component.exports